export default {
  ReportsMenuAdvanceModeEnabled: 'ReportsMenuAdvanceModeEnabled',
}
